export type NavGraphVariant =
   'GRAPH1' |
   'GRAPH2';

export type EdgeDirection =
   'FWD' |     // Focus Melder 320: edge zeigt vom Element weg zu einem anderem Element: Meldung 320 meldet an Meldung 301
   'BKWD';     // Focus Melder 320: edge zeigt zum Element hin: KomponenteMelder/1 meldet an Melder 320

export interface ITreeNode {
   id: number;
   _id: string;
   nodeAbbr?: string;
   modeGroup?: string;
   nodeGroupUi?: string;
   nodeGroupAbbrUi?: string;
   bezeichnung: string;
   isExpanded: boolean;
   type: string;
   schaltzustaende?: ISchaltzustand[];
   schaltzustandValue?: string;
   additionalAbbr?: string;
   additional?: string;
   edgeGroup?: string;
   children: ITreeEdge[];
   style?: {};
   refEdgeId?: string;
}

export interface ITreeEdge {
   id: number;
   edgeGroupUi: string;
   edgeGroup: string;
   edgeDirection: 'FWD' | 'BKWD';
   isExpanded: boolean;
   type: string;
   children: ITreeNode[];
   style?: {};
}

export interface ISchaltzustand {
   value: string;
   uiMessage: string;
}

export const EdgeDirectionFWD = 'FWD';
export const EdgeDirectionBKWD = 'BKWD';

// nav list node types
export const NavListNodeType_root = 'root';
export const NavListNodeType_edgeLevel1 = 'edgeLevel1';
export const NavListNodeType_edgeLevel2 = 'edgeLevel2';
export const NavListNodeType_nodeLevel1 = 'nodeLevel1';
export const NavListNodeType_nodeLevel2 = 'nodeLevel2';



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav.types.ts